import { Data } from './types'

export const data: Data = {
    companyDepartmentUsers: [], // potential
    user: null,
    controlLists: {}
}
